import { NewsletterOfferWorkerClient } from "./NewsletterOfferWorkerClient"
import type {
  NewsletterOfferBroadcastJob,
  NewsletterOfferBroadcastStartResponse,
} from "./types/newsletterOffer"

const broadcastOffer = (offerId: string) =>
  NewsletterOfferWorkerClient.post<undefined, NewsletterOfferBroadcastStartResponse>(
    `/newsletter-offer/${encodeURIComponent(offerId)}`,
  )

const getBroadcastJob = (jobId: string) =>
  NewsletterOfferWorkerClient.get<undefined, NewsletterOfferBroadcastJob>(
    `/newsletter-offer/jobs/${encodeURIComponent(jobId)}`,
  )

export const NewsletterOfferService = {
  broadcastOffer,
  getBroadcastJob,
}
